import { gql } from '@apollo/client';

export const ADD_USER_INTREST = gql`
  mutation InterestedInEventCategory($interestId:Int!,$personId:Int!) {
    interestedInEventCategory(interestId:$interestId,personId:$personId)
  }
`;

export const DELETE_USER_INTREST = gql`
  mutation NotInterestedInEventCategory($interestId:Int!,$personId:Int!) {
    notInterestedInEventCategory(interestId:$interestId,personId:$personId)
  }
`;

export const ADD_USER_CHILD = gql`
  mutation AddUserChild($personId:Int,$children:[Child]) {
    addUserChild(personId:$personId,children:$children)
  }
`;

export const DELETE_USER_CHILD = gql`
  mutation DeleteUserChild($childId:Int) {
    deleteUserChild(childId:$childId)
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile($personId:Int,$person:PersonInput,$address:AddressInput) {
    updateUserProfile(personId:$personId,person:$person,address:$address)
  }
`;

export const UPDATE_USER_PROFILE_HEADSHOT = gql`
  mutation UpdateUserProfileHeadshot($fileName:String,$isAvatar:Boolean,$mimeType:String,$personId:Int) {
    postHeadShot(fileName:$fileName,isAvatar:$isAvatar,mimeType:$mimeType,personId:$personId)
  }
`;

export const EMAIL_CHANGE_OTP = gql`
  mutation EmailChangeOtp($otp:Int,$email:String) {
    emailChangeOtp(otp:$otp,email:$email)
  }
`;

export const EMAIL_CHANGE = gql`
  mutation EmailChange($otp:Int,$email:String) {
    emailChange(otp:$otp,email:$email)
  }
`;

export const DELETE_ACCOUNT_OTP = gql`
  mutation DeleteAccountOtp {
    deleteAccountOtp
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation DeleteAccount($reason:String,$otp:String,$channel:String) {
    deleteAccount(reason:$reason,otp:$otp,channel:$channel)
  }
`;
